import React, { useEffect, useState } from "react";
import moment from "moment";
import Slot from "./Slot";
import SpecialSlots from "./SpecialSlots";
import { useLocation, useNavigate } from "react-router-dom";
import StatusComp from "../../../components/StatusComp";

const AdminSlotMain = () => {
  const [activeTab, setActiveTab] = useState("week");

  const location = useLocation();
  const superAdmin = location.state?.superAdmin;
  console.log("superAdmin", superAdmin);

  const navigate = useNavigate();
  const data = location?.state?.data;
  const type = location?.state?.type;

  // useEffect(() => {
  //   const slotDays = JSON.parse(localStorage.getItem("slotDays"));
  //   if (slotDays) {
  //     setActiveTab(slotDays);
  //   } else {
  //     setActiveTab("week");
  //     localStorage.setItem("slotDays", JSON.stringify("week"));
  //   }
  // }, []);

  const handleTab = (days) => {
    setActiveTab(days);
    localStorage.setItem("slotDays", JSON.stringify(days));
  };

  const createdAt = moment().format("DD-MM-YYYY");

  return (
    <div className="dashRightView">
      <StatusComp name={"Slot days"} />

      {type && (
        <div className="d-flex ">
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Company Name & Code
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={`${data?.companyName ?? "Ninos"} - ${
                  data?.companyId ?? "N001"
                }`}
              />
            </div>

            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Site Name & Code
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={`${data?.siteName ?? "Robotics"} - ${
                  data?.siteCode ?? "R001"
                }`}
              />
            </div>
          </div>
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Site Location
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={data?.siteLocation ?? "Chennai,vadapalani"}
              />
            </div>
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Site Admin
              </p>
              <input
                className="input-box w-100"
                readOnly
                value={data?.siteAdminName ?? "Shakthivel"}
              />
            </div>
          </div>
          <div className="col-md-4 p-3">
            <div className="p-2 mb-2">
              <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
                Admin Created On
              </p>
              <input className="input-box w-100" readOnly value={createdAt} />
            </div>
          </div>
        </div>
      )}

      {type && (
        <div className="col-md-12 p-3 d-flex ac-js mb-5 gap-5">
          <div className="p-2 mb-2">
            <button
              className="back-btn px-4"
              onClick={() =>
                navigate("/site-report", {
                  state: { type: "site-view", data: data },
                })
              }
            >
              View Report
            </button>
          </div>
          <div className="p-2 mb-2">
            <button
              className="back-btn px-4"
              onClick={() =>
                navigate("/admin-notifications", {
                  state: { type: "site-view", data: data },
                })
              }
            >
              View Notifications
            </button>
          </div>

          <div className="p-2 mb-2">
            <button className="submit-btn px-4">View slot days</button>
          </div>

          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() =>
                navigate("/admin-alert-types", {
                  state: {
                    type: "site-view",
                    data: data,
                  },
                })
              }
            >
              Alert Types
            </button>
          </div>

          <div className="p-2 mb-2">
            <button
              className="back-btn"
              onClick={() =>
                navigate("/admin-cameras", {
                  state: {
                    type: "site-view",
                    data: data,
                  },
                })
              }
            >
              Cameras
            </button>
          </div>
        </div>
      )}

      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab === "week" ? "active" : ""}`}
          onClick={() => handleTab("week")}
        >
          Week days
        </button>
        <button
          className={`tab-btn ${activeTab === "special" ? "active" : ""}`}
          onClick={() => handleTab("special")}
        >
          Special Holidays
        </button>
      </div>

      <div>
        {activeTab == "week" && <Slot superAdmin={superAdmin} />}
        {activeTab == "special" && <SpecialSlots superAdmin={superAdmin} />}
      </div>
    </div>
  );
};

export default AdminSlotMain;
